var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "#F4F4F4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 54C43.2548 54 54 43.2548 54 30C54 16.7452 43.2548 6 30 6C16.7452 6 6 16.7452 6 30C6 43.2548 16.7452 54 30 54Z",
    fill: "#D8761C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9498 32.1003V22.6503H31.0498V32.1003H28.9498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 37.3503C30.8697 37.3503 31.5748 36.6451 31.5748 35.7753C31.5748 34.9054 30.8697 34.2003 29.9998 34.2003C29.13 34.2003 28.4248 34.9054 28.4248 35.7753C28.4248 36.6451 29.13 37.3503 29.9998 37.3503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9998 44.7003C38.1184 44.7003 44.6998 38.1189 44.6998 30.0003C44.6998 21.8817 38.1184 15.3003 29.9998 15.3003C21.8812 15.3003 15.2998 21.8817 15.2998 30.0003C15.2998 38.1189 21.8812 44.7003 29.9998 44.7003ZM29.9998 42.6003C36.9586 42.6003 42.5998 36.9591 42.5998 30.0003C42.5998 23.0415 36.9586 17.4003 29.9998 17.4003C23.041 17.4003 17.3998 23.0415 17.3998 30.0003C17.3998 36.9591 23.041 42.6003 29.9998 42.6003Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderError);
export default __webpack_public_path__ + "static/media/loader_error.12073379545434e6262e3b33b4fbadd8.svg";
export { ForwardRef as ReactComponent };